import { Box, Button, Grid } from "@mui/material";
import {
    EnhancedButtonPrimeReact,
    EnhancedButtonPrimeReactSeverity,
    EnhancedDropDownRHFWithLabel,
    EnhancedTextAreaFieldRHF,
    LabelPosition,
    RHookFormDatePicker,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface IPaydayAdvanceInfoSetupFieldsPanel {
    isExporting: boolean;
    employeeDDL: any;
    handleImportClick: (tag: string) => void
    formMethods: any;
    exportDataPageName: string;
}

export const PaydayAdvanceInfoSetupFieldsPanel: FC<
    IPaydayAdvanceInfoSetupFieldsPanel
> = ({ employeeDDL, isExporting, handleImportClick, formMethods, exportDataPageName }) => {
    const currentYear = new Date().getFullYear();

    useEffect(() => {

        formMethods.reset({
            ...formMethods.getValues(),

            stDate: new Date(currentYear, 0, 1),
            enDate: new Date(),
        });

    }, [])
    return (
        <>
            <EnhancedDropDownRHFWithLabel
                selectName={"employeeId"}
                items={employeeDDL ?? []}
                selectedItem={"all"}
                label={"Employee"}
                testId={"employee-ddl"}
                showEmpty
            />
            <Grid
                container
                spacing={2}
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            >
                <Grid
                    size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}
                    sx={{
                        "& .MuiBox-root": {
                            paddingTop: "3px !important",
                        },
                        "& .calenderWrapper": {
                            width: "100% !important",
                            minWidth: "unset !important",
                        },
                    }}
                >
                    <RHookFormDatePicker
                        name="stDate"
                        testId="start-date"
                        label="From"
                        format="M dd, yy"
                        defaultValue={new Date(currentYear, 0, 1)}
                    />
                </Grid>

                <Grid
                    size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}
                    sx={{
                        "& .MuiBox-root": {
                            paddingTop: "3px !important",
                        },
                        "& .calenderWrapper": {
                            // marginTop: "19px !important",
                            marginBottom: "0 !important",
                            width: "100% !important",
                            minWidth: "unset !important",
                        },
                    }}
                >
                    <RHookFormDatePicker
                        name="enDate"
                        testId="end-date"
                        label="To"
                        format="M dd, yy"
                        defaultValue={new Date()}
                    />
                </Grid>
            </Grid>

            {exportDataPageName !== "quick_books" && <RHookFormDatePicker
                name="exportDate"
                testId="export-date"
                label="Export Date"
                format="M dd, yy"
            />}
            {exportDataPageName !== "quick_books" && <RHookFormTextFieldWithLabel
                label="Reference No"
                id="referenceNo"
                testId={`reference-no`}
                labelPosition={LabelPosition.Top}
            />}

            {exportDataPageName === "quick_books" && <RHookFormTextFieldWithLabel
                label="G/L Reference"
                id="glReference"
                testId={`gl-reference`}
                labelPosition={LabelPosition.Top}
            />}
            {exportDataPageName === "quick_books" && <EnhancedTextAreaFieldRHF
                label="Memo"
                id="memo"
                testId={`memo`}
                labelPosition={LabelPosition.Top}
            />}
            <EnhancedButtonPrimeReact
                label={exportDataPageName === "quick_books" ? "Export to QuickBooks" : "Export"}
                // type="submit"
                raised
                severity={EnhancedButtonPrimeReactSeverity.Secondary}
                loading={isExporting}
                onClickHandler={() => handleImportClick("payday_advance")}
            />
        </>
    );
};
